import { HomeEntity, MainMenuEntity } from '@/lib/api/entity'
import { createContext } from 'react'

export type AppContextProps = {
  mainMenu: MainMenuEntity | null
  home: HomeEntity | null
}
export const AppContext = createContext<AppContextProps>({
  mainMenu: null,
  home: null,
})
